import { DialogContent, DialogOverlay } from '@reach/dialog'

import Typography from '~/components/Typography'
import {
	hasCoin98Extension,
	hasImTokenExtension,
	hasMetamaskExtension,
	hasTrustExtension,
	hasXDEFIExtension,
	hasOntoExtension,
	useWallet,
	WalletType,
	hasBitKeepExtension,
	hasOperaExtension,
	hasKuCoinExtension,
	hasSafePalExtension,
} from '~/lib/useWallet'

import { WalletLink } from './WalletLink'
import CrossIcon from './assets/cross.svg'

import styles from './ConnectWalletModal.pcss'

interface Props {
	show: boolean
	onDismiss: () => void
}

const WALLET_TYPES: WalletType[] = [
	WalletType.METAMASK,
	WalletType.BLOCKCHAIN_COM,
	WalletType.OPERA,
	WalletType.XDEFI,
	WalletType.SAFE_PAL,
	WalletType.WALLET_CONNECT,
	WalletType.TRUST,
	WalletType.COIN98,
	WalletType.ONTO,
	WalletType.IM_TOKEN,
	WalletType.BITKEEP,
	WalletType.KUCOIN,
]

export function ConnectWalletModal({ show, onDismiss }: Props) {
	const { connect } = useWallet()

	const hasWallet = window['ethereum']

	const onWalletLinkClick = (event, walletName) => {
		if (
			!(
				walletName === WalletType.WALLET_CONNECT ||
				walletName === WalletType.BLOCKCHAIN_COM ||
				hasWallet
			)
		) {
			return
		}

		if (
			(!hasCoin98Extension() && walletName === WalletType.COIN98) ||
			(!hasImTokenExtension() && walletName === WalletType.IM_TOKEN) ||
			(!hasBitKeepExtension() && walletName === WalletType.BITKEEP) ||
			(!hasMetamaskExtension() && walletName === WalletType.METAMASK) ||
			(!hasTrustExtension() && walletName === WalletType.TRUST) ||
			(!hasXDEFIExtension() && walletName === WalletType.XDEFI) ||
			(!hasOntoExtension() && walletName === WalletType.ONTO) ||
			(!hasOperaExtension() && walletName === WalletType.OPERA) ||
			(!hasKuCoinExtension() && walletName === WalletType.KUCOIN) ||
			(!hasSafePalExtension() && walletName === WalletType.SAFE_PAL)
		) {
			return
		}

		event.preventDefault()
		connect(walletName)
	}

	return (
		<DialogOverlay
			className={styles.overlay}
			isOpen={show}
			onDismiss={onDismiss}
		>
			<DialogContent className={styles.container}>
				<button
					className={styles.dismiss}
					onClick={onDismiss}
					data-qa="close-modal-button"
				>
					<CrossIcon className={styles.cross} />
				</button>

				<div className={styles.content}>
					<div className={styles.title}>
						{hasWallet ? 'Connect to a wallet' : 'Install a wallet'}
					</div>

					{!hasWallet && (
						<Typography size="S" color="gray">
							You don`t have wallet plugins installed, please
							select one from the list and install
						</Typography>
					)}

					<div className={styles.wallets}>
						{WALLET_TYPES.map((type) => {
							return (
								<WalletLink
									key={type}
									walletType={type as WalletType}
									onClick={onWalletLinkClick}
								/>
							)
						})}
					</div>
				</div>
			</DialogContent>
		</DialogOverlay>
	)
}
